(function(){
    'use strict'

    angular
    .module('app.vacacionesDetalle')
    .controller('VacacionesDetalle', VacacionesDetalle);

    VacacionesDetalle.$inject = ['$scope', '$animationsSrv', 'VacacionesDetalleService', 'logger', 'UserInfoService', 'TiposPlanillaService'];

    function VacacionesDetalle($scope, $animationsSrv, VacacionesDetalleService, logger, UserInfoService, TiposPlanillaService) {
    
        $animationsSrv.scrollToTop();
        
        var vm = this;

        vm.tiposPlanilla = [];
        vm.periodos = [];
        vm.vacaciones = [];

        vm.title = 'VacacionesDetalle';

        vm.vacacionesDetalle = {
            tipoPlanillaId: -1,
            periodo: -1,
            companiaId: UserInfoService.getCompaniaId()
        };

        getTiposPlanilla();
        getAllPeriodos();

        function getTiposPlanilla(){
            var promise = TiposPlanillaService.getAllForCalendarizacion(UserInfoService.getCompaniaId())
            .then(function(tiposPlanilla){
                tiposPlanilla.forEach(tipo => {
                    tipo.fechaInicio = moment(tipo.fechaInicio).toDate();
                    tipo.fechaFinal = moment(tipo.fechaFinal).toDate();
                });
                vm.tiposPlanilla = tiposPlanilla;
            })
            .catch(function(error){
                $logger.error('Error al obtener los tipos de planilla.');
            }); 
            
            return promise;
        };

        function getAllPeriodos(){

            var promise = VacacionesDetalleService.getPeriodos();

            promise
            .then(function(periodos){
                vm.periodos = periodos;
            })
            .catch(function(error){
                switch (error.status) {
                    case 401:
                        logger.error('La sessión ha terminado.');
                        break;
                
                    default:
                        logger.error('Error al obtener los Periodos.');
                        break;
                }
                
            });
        };

        function validateTipoPlanilla(){
            if(vm.vacacionesDetalle.tipoPlanillaId == -1){
                $scope.vacacionesDetalleForm.tipoPlanillaId.$setValidity("different", false);
            }
            else{
                $scope.vacacionesDetalleForm.tipoPlanillaId.$setValidity("different", true);
            }
        };

        function validatePeriodo(){
            if(vm.vacacionesDetalle.periodo == -1){
                $scope.vacacionesDetalleForm.periodo.$setValidity("different", false);
            }
            else{
                $scope.vacacionesDetalleForm.periodo.$setValidity("different", true);
            }
        };

        function doFormValidations(){
            validateTipoPlanilla();
            validatePeriodo();
        };

        vm.procesar = function(){
            
            $scope.submitted = true;
            doFormValidations();

            if(!$scope.vacacionesDetalleForm.$valid){
                return;
            }

            var promise = VacacionesDetalleService.procesar(vm.vacacionesDetalle);

            promise.then(function (response) {
                vm.vacaciones = response.data;
                logger.success('Vacaciones procesadas con Éxito.');
            })
            .catch(function(error){
                switch (error.status) {
                    case 500:
                        logger.error(error.data.Message);
                        break;
                    case 401:
                        logger.error('La sessión ha terminado.');
                        break;
                    default:
                        logger.error('Hubo un error al procesar las vacaciones. ' + error.data.Message);
                        break;
                }
                
            });

        };

        vm.cargar = function(){

            $scope.submitted = true;
            doFormValidations();

            if(!$scope.vacacionesDetalleForm.$valid){
                return;
            }

            VacacionesDetalleService.getAll(vm.vacacionesDetalle.tipoPlanillaId, vm.vacacionesDetalle.periodo)
            .then(function(vacaciones){
                vm.vacaciones = vacaciones;
            })
            .catch(function(error){
                $logger.error('Error al obtener el detalle de las vacaciones.');
            }); 
        };

    }
})();